import { Type, Transform } from "class-transformer";
import { TransformDate } from '../../decorators';

export class WaitQueue {
    studentID: number;
    studentFullName: string;

    @TransformDate()
    createdAt: Date;
}